import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

/**
 * Central auth utility. Token is stored in httpOnly cookie by the backend.
 * We keep a minimal in-memory copy for headers (backward compat) and
 * user info in sessionStorage (not the token itself).
 */
let memoryToken = null;

export const auth = {
  login: async (username, password, recaptchaToken) => {
    const res = await axios.post(`${API}/auth/login`, {
      username, password, recaptcha_token: recaptchaToken
    }, { withCredentials: true });

    memoryToken = res.data.token;
    sessionStorage.setItem('admin_user', JSON.stringify(res.data.user));
    return res.data;
  },

  logout: async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch (_) { /* ignore */ }
    memoryToken = null;
    sessionStorage.removeItem('admin_user');
    localStorage.removeItem('token');
    localStorage.removeItem('admin_user');
  },

  getToken: () => {
    if (memoryToken) return memoryToken;
    // Migration: read from old localStorage if present, then clear it
    const old = localStorage.getItem('token');
    if (old) {
      memoryToken = old;
      localStorage.removeItem('token');
    }
    return memoryToken;
  },

  getUser: () => {
    const data = sessionStorage.getItem('admin_user')
      || localStorage.getItem('admin_user');
    if (!data) return null;
    try { return JSON.parse(data); } catch { return null; }
  },

  isAuthenticated: () => !!auth.getToken(),

  /** Pre-configured axios instance that sends cookie + bearer */
  api: () => {
    const token = auth.getToken();
    return axios.create({
      baseURL: API,
      withCredentials: true,
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
  }
};
